import avatar from '../../../assets/images/avatar.png'

interface ProfileHeaderProps {
  user: any
}

const ProfileHeader = ({ user }: ProfileHeaderProps) => {
  return (
    <div className="profile-header">
      <div className="profile-avatar">
        {user?.photo_url ? (
          <img src={user.photo_url} alt="Avatar" className="avatar-image" />
        ) : (
          <img src={avatar} alt="Avatar" className="avatar-image" />
        )}
      </div>
      <div className="profile-info">
        <h1 className="profile-name">
          {user ? `${user.first_name} ${user.last_name || ''}`.trim() : 'Guest'}
        </h1>
        {user?.username && <p className="profile-username">@{user.username}</p>}
      </div>
    </div>
  )
}

export default ProfileHeader
